// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"bf4f72c7","151":"bd992318","585":"d0811d72"}[chunkId] + ".chunk.js";
};